import React from 'react';

// Components
import { Hyperlink } from '../../../components/atoms/Hyperlink';

type UserProfileSelectionProps = {
  headline: React.ReactElement | string;
  helpText?: string;
  profileLink?: string;
  profileLinkText?: string;
  logoutLink?: string;
  logoutLinkText?: string;
  loginLink?: string;
  loginLinkText?: string;
};

/**
 * The component aggregates contents from UserAccount or UserAnonymous to this point,
 * where all the design (CSS) is based
 */
export function UserProfileSelection(props: UserProfileSelectionProps) {
  const getSelectionItem = (to: string | undefined, child: any, routing = true) => {
    return to
      ? (
          <li className="user-profile-selection__listitem">
            <Hyperlink to={to} className="user-profile-selection__link" routing={routing}>
              {child}
            </Hyperlink>
          </li>
        )
      : null;
  };

  // no empty table
  if (!props.profileLink && !props.logoutLink && !props.loginLink) {
    return null;
  }
  return (
    <div id="user-profile-selection" className="user-profile-selection">
      <h3 className="user-profile-selection__headline">{props.headline}</h3>
      {props.helpText ? <p className="user-profile-selection__helptext">{props.helpText}</p> : null}
      <ul className="user-profile-selection__list">
        {getSelectionItem(props.profileLink, props.profileLinkText)}
        {getSelectionItem(props.logoutLink, props.logoutLinkText, false)}
        {getSelectionItem(props.loginLink, props.loginLinkText, false)}{' '}
      </ul>
    </div>
  );
}
